import React from "react";

/**
 * Animated bull/bear radar signal dot.
 *  variant: "bull" | "bear" | "neutral"
 *  strength: "light" | "medium" | "strong"
 */
export default function SignalDot({ variant = "bull", strength = "light", size = 10, className = "" }) {
  const color =
    variant === "bull" ? "#00ff9c" : variant === "bear" ? "#ff4d6d" : "#c0c0cc";
  const rings = strength === "strong" ? 2 : strength === "medium" ? 1 : 0;
  return (
    <span
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size + 16, height: size + 16 }}
      aria-hidden
      data-testid={`signal-dot-${variant}`}
    >
      {/* outer radar rings */}
      {Array.from({ length: rings + 1 }).map((_, i) => (
        <span
          key={i}
          className="absolute rounded-full"
          style={{
            width: size + 2,
            height: size + 2,
            border: `1px solid ${color}`,
            opacity: 0.35,
            animation: `radar-ping ${1.4 + i * 0.3}s ease-out ${i * 0.25}s infinite`,
          }}
        />
      ))}
      <span
        className="relative rounded-full"
        style={{
          width: size,
          height: size,
          background: color,
          boxShadow: `0 0 ${strength === "strong" ? 16 : 10}px ${color}`,
        }}
      />
    </span>
  );
}
